/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./UploadDocumentsSuccess.vue?vue&type=template&id=18537346"
import script from "./UploadDocumentsSuccess.vue?vue&type=script&lang=js"
export * from "./UploadDocumentsSuccess.vue?vue&type=script&lang=js"
import style0 from "./UploadDocumentsSuccess.vue?vue&type=style&index=0&id=18537346&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports